import React from "react";
import Avatar from "./Avatar";

// Foto (BenDesk/MS365) + nome, com fallback de iniciais (via <Avatar>).
// Usado nas colunas Solicitante/Responsável (lista e detalhe do chamado).
export default function PersonChip({ name, src, placeholder = "—", className = "" }) {
  if (!name) return <span className="text-sm text-gray-400">{placeholder}</span>;
  return (
    <span className={`inline-flex items-center gap-2 min-w-0 ${className}`}>
      <Avatar src={src} name={name} className="h-7 w-7 shrink-0" textClassName="text-[11px]" />
      <span className="truncate">{name}</span>
    </span>
  );
}
